import { useStepperStore } from '@nx-paeonia/feature-product-configurator';
import { ArkErrors } from 'arktype';
import { DataFormat } from '../../domain/product-configurator-step.data.js';

const TAG = 'y-configurator-timeline';

/**
 * Custom element for a configurator timeline.
 *
 * Registers as "y-configurator-timeline".
 *
 * TODO: Make this use the StepperStore to directly modify the steps.
 */
export class YConfiguratorTimeline extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    useStepperStore().subscribe((currentState, previousState) => {
      if (currentState.steps.activeStep !== previousState.steps.activeStep) {
        this.onPageChange();
      }
    });
    this.update();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  private readonly onClick = (e: Event) => {
    e.preventDefault();
    const target = e.target as HTMLElement;
    if (target.matches('a')) {
      const targetUrl = target.getAttribute('href') || '';
      useStepperStore().getState().steps.goToStep(targetUrl.replace('#', ''));
    }
  };

  private readonly onPageChange = () => {
    const activeStep = useStepperStore().getState().steps.activeStep;
    const data = document.querySelector(`#${activeStep} script.product-configurator-step-data`);
    if (!data) return;
    const parsed = DataFormat(JSON.parse(data.textContent || '{}'));
    if (parsed instanceof ArkErrors) return;

    this.querySelector('[aria-current]')?.removeAttribute('aria-current');
    const stepEl = this.querySelector(parsed.selectors.timeline);
    if (stepEl) stepEl.setAttribute('aria-current', 'step');

    if (!parsed.showInTimeline) {
      stepEl?.remove();
    }
  };

  private update() {
    const dataItems = document.querySelectorAll('script.product-configurator-step-data');
    Array.from(dataItems).forEach((el) => {
      const parsed = DataFormat(JSON.parse(el.textContent || '{}'));
      if (parsed instanceof ArkErrors) return;

      // Find the right step element in the timeline
      const stepEl = this.querySelector(parsed.selectors.timeline);
      if (stepEl?.firstElementChild?.firstElementChild) {
        stepEl.firstElementChild.firstElementChild.textContent = parsed.title;
      }
    });
  }
}

if (!customElements.get(TAG)) {
  customElements.define(TAG, YConfiguratorTimeline);
}
